import React from "react";
import {
  canEditOpeningBalanceFields,
  formatOpeningBalanceDisplayDate,
  getOpeningBalanceMinDate,
  shouldShowOpeningBalanceDateField,
} from '../../utils/openingBalanceDate'
import OpeningBalanceUnlockButton from '../../utils/OpeningBalanceUnlockButton'

const FleetCardModal = ({
  isShowing,preventNonNumericalInput,prevNonNumericalWithDec,
  success,
  hide,
  errors,
  inputValues,
  double,
  handleSubmit,
  stat_operation,
  handleInputs,handleInput,
  canEditOpeningBalance,
  onUnlockOpeningBalance,
  isOwnerRole,
}) => {
  const canEditOpeningFields = canEditOpeningBalanceFields({
    statOperation: stat_operation,
    openingBalanceUnlocked: canEditOpeningBalance,
  });
  const showOpeningBalanceFields = stat_operation !== "Yes" || canEditOpeningFields;
  const showOpeningBalanceDateField = shouldShowOpeningBalanceDateField({
    statOperation: stat_operation,
    openingBalanceUnlocked: canEditOpeningBalance,
  });

  const formatOpeningBalanceDisplay = (amount, debitCredit) => {
    const numericAmount = Number(amount || 0);
    const formattedAmount = numericAmount.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return debitCredit === 'Dr' ? `(${formattedAmount})` : formattedAmount;
  };

  return (
    <React.Fragment>
      <div className="modal-overlay" />
      <div
        className="modal-wrapper"
        aria-modal
        aria-hidden
        tabIndex={-1}
        role="dialog"
      >
        <div className="modal modalm">
          <div className="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {inputValues?.id ? "EDIT FLEET CARD" : "ADD FLEET CARD"}
            </h5>
            <div className="d-flex align-items-center gap-2">
              <OpeningBalanceUnlockButton
                statOperation={stat_operation}
                unlocked={Boolean(canEditOpeningBalance)}
                canUnlock={isOwnerRole}
                onUnlock={onUnlockOpeningBalance}
              />
            <button
              type="button"
              className="modal-close-button"
              data-dismiss="modal"
              aria-label="Close"
              onClick={hide}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            </div>
          </div>
          
          <div className="form-group mt-2">
            <label>Name <sup class="star">*</sup></label>
            <input
              type="text"
              className="form-control "
              name="name"
              value={inputValues["name"] || ''}
              onChange={handleInputs}
            />
            <div className="errorMsg">{errors.name}</div>
          </div>

          <div className="row">
          {showOpeningBalanceFields ?
           <div className="form-group">
           <label>Opening Balance<sup class="star">*</sup></label>
             <input
               type="number"
               onKeyPress={(event)=>preventNonNumericalInput(event,event.target.value)}
               className="form-control hide-arrow"
               id={"open"}
               name="opening_balance"
               value={inputValues["opening_balance"] ?? ''}
               onChange={handleInput}
               readOnly={!canEditOpeningFields}
             />
             <div className="errorMsg">{errors.opening_balance}</div>
             <span className="amount-words"></span>
           </div>
           :""}

          {showOpeningBalanceDateField ? (
            <div className="form-group mb-3">
              <label>Opening Balance Date</label>
              <input
                type="date"
                className="form-control"
                name="ac_date"
                value={inputValues.ac_date || ''}
                min={getOpeningBalanceMinDate()}
                onChange={handleInputs}
                readOnly={!canEditOpeningFields}
                disabled={!canEditOpeningFields}
              />
            </div>
          ) : null}

            <div className="col-md-4 d-flex">
            </div>

            {Array.isArray(inputValues?.opening_balance_edit_history)
              && inputValues.opening_balance_edit_history.length > 0 && (
              <div className="col-12 mt-3">
                <h6 className="mb-2">Opening Balance Edit History</h6>
                <div className="table-responsive">
                  <table className="table table-sm table-bordered">
                    <thead>
                      <tr>
                        <th>Previous Value</th>
                        <th>Previous Date</th>
                        <th>New Value</th>
                        <th>New Date</th>
                        <th>Edited By</th>
                        <th>Edited At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {inputValues.opening_balance_edit_history.map((log, idx) => (
                        <tr key={`fleet-ob-log-${idx}`}>
                          <td>
                            {formatOpeningBalanceDisplay(
                              log.previous_opening_balance,
                              log.previous_debit_credit
                            )}
                          </td>
                          <td>{formatOpeningBalanceDisplayDate(log.previous_ac_date) || '—'}</td>
                          <td>
                            {formatOpeningBalanceDisplay(
                              log.new_opening_balance,
                              log.new_debit_credit
                            )}
                          </td>
                          <td>{formatOpeningBalanceDisplayDate(log.new_ac_date) || '—'}</td>
                          <td>{log.edited_by || 'Unknown'}</td>
                          <td>
                            {log.edited_at
                              ? new Date(log.edited_at).toLocaleString('en-IN')
                              : '—'}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <div class="modal-footer">
              {double=== true ? (
                <button
                  type="submit"
                  class="btn btn-primary"
                  onClick={handleSubmit}
                >
                  Save
                </button>
              ) : (
                  <button
                    type="submit"
                    class="btn btn-primary"
                    disabled
                  >
                    Save
                  </button>
                )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default FleetCardModal;
